module.exports = __webpack_public_path__ + "static/media/background.85676e78.png";